function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.25 12.8184C9.25 12.8184 12.25 6.81836 17.5 6.81836C22.75 6.81836 25.75 12.8184 25.75 12.8184C25.75 12.8184 22.75 18.8184 17.5 18.8184C12.25 18.8184 9.25 12.8184 9.25 12.8184Z",
  stroke: "#B6B6B6",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 15.0684C18.7426 15.0684 19.75 14.061 19.75 12.8184C19.75 11.5757 18.7426 10.5684 17.5 10.5684C16.2574 10.5684 15.25 11.5757 15.25 12.8184C15.25 14.061 16.2574 15.0684 17.5 15.0684Z",
  stroke: "#B6B6B6",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgEyeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.2fc046d7.svg";
export { ForwardRef as ReactComponent };